import type { ComponentType } from 'react';
import type { AccountTypeIcon } from '../../../lib/onboardingProfile';
import { LawyerRoleIcon } from './LawyerRoleIcon';
import { LawFirmRoleIcon } from './LawFirmRoleIcon';
import { LawStudentRoleIcon } from './LawStudentRoleIcon';
import type { OnboardingIconProps } from './OnboardingIconProps';

export const ONBOARDING_ROLE_ICONS: Record<
  AccountTypeIcon,
  ComponentType<OnboardingIconProps>
> = {
  Briefcase: LawyerRoleIcon,
  Building2: LawFirmRoleIcon,
  GraduationCap: LawStudentRoleIcon,
};

export { LawyerRoleIcon, LawFirmRoleIcon, LawStudentRoleIcon };
